export const formatHubspotBody = (body: string, url: string): string => {
  return body
    .replace(
      /({{cta\(')([a-z0-9-]+)(',')?([a-z]+)?('\)}})/g,
      `<a href="https://cta-redirect.hubspot.com/cta/redirect/4047198/$2" class="hubspot-cta $4" target="_blank"><img src="https://no-cache.hubspot.com/cta/default/4047198/$2.png"  alt="" /></a>`,
    )
    .replace(
      /{% video_player(.*?)%}/g,
      `<p>Videota ei voi näyttää tässä. <a href="${url}" style="text-decoration: underline" target="_blank">Katso video Lumme Energian verkkosivuilla.</a></p>`,
    );
};
